import { B2ListGroup } from "@hdb/biome-2";
import React, { useEffect, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import InfiniteScroll from "react-infinite-scroll-component";
import { useParams } from "react-router-dom";
import { safeAtob } from "src/shared/helpers/enode-decode-string";
import StatusDisplay from "./dashboard-floorplan-status-display";

interface DefaultListProps {
  dataItems: any[];
  isLoadingFloors: boolean;
  hasMore: boolean;
  fetchMoreData: () => void;
  navigateToUrl: (
    url: string,
    isReplaced?: boolean,
    isClicked?: boolean
  ) => void;
}

const DefaultList: React.FC<DefaultListProps> = ({
  dataItems,
  isLoadingFloors,
  hasMore,
  fetchMoreData,
  navigateToUrl,
}) => {
  const params: any = useParams();
  const blockCode: any = params.blockCode ? safeAtob(params.blockCode) : null;
  const floor = params?.floor;

  // Responsive height state
  const [scrollHeight, setScrollHeight] = useState(
    window.innerWidth > 1200 ? 1200 : 250
  );

  useEffect(() => {
    const handleResize = () => {
      setScrollHeight(window.innerWidth > 1200 ? 1200 : 250);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="w-lg-25 z-1 position-relative">
      <B2ListGroup>
        <div
          id="floor-scrollable-div"
          style={{
            maxHeight: scrollHeight,
            overflowY: "auto",
          }}
        >
          <InfiniteScroll
            scrollableTarget="floor-scrollable-div"
            dataLength={dataItems?.length ?? 0}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              <div className="text-center p-2">
                <Spinner
                  animation="border"
                  style={{ color: "#1976D2" }}
                  className="mt-5"
                />
              </div>
            }
            style={{ overflowX: "hidden" }}
            endMessage={
              <p style={{ textAlign: "center", paddingTop: "10px" }}>
                <b style={{ color: "#1976D2" }}>No More Data</b>
              </p>
            }
          >
            {dataItems?.map((item: any, i: any) => (
              <B2ListGroup.Item
                active={false}
                key={i}
                onClick={() =>
                  navigateToUrl(
                    encodeURIComponent(item?.FloorCode),
                    false,
                    true,
                  )
                }
                className={`hide-expand-icon cursor-pointer ${floor === item?.FloorCode ? "active active-without-child" : ""
                  }`}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    gap: "0.3rem",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      whiteSpace: "normal",
                      overflowWrap: "anywhere",
                      wordBreak: "break-all",
                    }}
                  >
                    {item?.FloorCode}
                  </div>
                  <StatusDisplay item={item} id={i} isFloorPlanView={true} />
                </div>
              </B2ListGroup.Item>
            ))}
          </InfiniteScroll>
        </div>
      </B2ListGroup>
    </div>
  );
};

export default DefaultList;
